import { render, staticRenderFns } from "./DialogOtherTask.vue?vue&type=template&id=3626aacb&"
import script from "./DialogOtherTask.vue?vue&type=script&lang=js&"
export * from "./DialogOtherTask.vue?vue&type=script&lang=js&"
import style0 from "./DialogOtherTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports